import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import socket from "./socket";

Vue.use(Vuex);

const vuexLocal = new VuexPersist({
  key: "client-bv-default",
  storage: window.localStorage,
  reducer: (state) => ({
    socket: {
      attendance: state.socket.attendance,
      messages: state.socket.messages,
      code: state.socket.code,
      socketSession: state.socket.socketSession,
    },
    requester: state.requester,
  }),
});

const vuexSession = new VuexPersist({
  key: "client-bv-comercial",
  storage: window.sessionStorage,
  modules: ["preSelection"],
});

export default new Vuex.Store({
  state: {
    module: "",
    preSelection: {},
    requester: {},
  },

  getters: {
    module: ({ module }) => module,
    preSelection: ({ preSelection }) => preSelection,
    requester: ({ requester }) => requester,
  },

  mutations: {
    SET_PRE_SELECTION(state, payload) {
      state.preSelection = payload;
    },

    SET_REQUESTER(state, payload) {
      state.requester = payload;
    },
  },

  actions: {
    setPreSelection({ commit }, payload) {
      commit("SET_PRE_SELECTION", payload);
    },

    setRequester({ commit }, payload) {
      commit("SET_REQUESTER", payload);
    },
  },

  plugins: [vuexLocal.plugin, vuexSession.plugin],

  modules: {
    socket,
  },
});
